// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LiftType } from "./lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A single LN2 message definition.
 *
 * message_content_type/enum_id/device_type together identify which wire
 * message this row backs; short_message/description are the human-facing
 * label/tooltip.
 */
export class Message implements flatbuffers.IUnpackableObject<MessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Message {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMessage(bb: flatbuffers.ByteBuffer, obj?: Message): Message {
    return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMessage(bb: flatbuffers.ByteBuffer, obj?: Message): Message {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  messageTypeId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  messageContentType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  enumId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  deviceType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  escalatorStatusMessageType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  elevatorStatusMessageType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  shortMessage(): string;
  shortMessage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  shortMessage(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  position(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Binary-encoded ControllerInfoContent payload (models.Message.CiDataBinary).
   */
  ciDataBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  ciDataBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  ciDataBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMessage(builder: flatbuffers.Builder) {
    builder.startObject(14);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addMessageTypeId(builder: flatbuffers.Builder, messageTypeId: number) {
    builder.addFieldInt32(1, messageTypeId, 0);
  }

  static addMessageContentType(builder: flatbuffers.Builder, messageContentType: number) {
    builder.addFieldInt16(2, messageContentType, 0);
  }

  static addEnumId(builder: flatbuffers.Builder, enumId: number) {
    builder.addFieldInt32(3, enumId, 0);
  }

  static addDeviceType(builder: flatbuffers.Builder, deviceType: LiftType) {
    builder.addFieldInt8(4, deviceType, LiftType.ELEVATOR);
  }

  static addEscalatorStatusMessageType(
    builder: flatbuffers.Builder,
    escalatorStatusMessageType: number,
  ) {
    builder.addFieldInt32(5, escalatorStatusMessageType, 0);
  }

  static addElevatorStatusMessageType(
    builder: flatbuffers.Builder,
    elevatorStatusMessageType: number,
  ) {
    builder.addFieldInt32(6, elevatorStatusMessageType, 0);
  }

  static addShortMessage(builder: flatbuffers.Builder, shortMessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, shortMessageOffset, 0);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, descriptionOffset, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: boolean) {
    builder.addFieldInt8(9, +position, +false);
  }

  static addCiDataBinary(builder: flatbuffers.Builder, ciDataBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, ciDataBinaryOffset, 0);
  }

  static createCiDataBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCiDataBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, deletedAtOffset, 0);
  }

  static endMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 18); // short_message
    return offset;
  }

  static createMessage(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    messageTypeId: number,
    messageContentType: number,
    enumId: number,
    deviceType: LiftType,
    escalatorStatusMessageType: number,
    elevatorStatusMessageType: number,
    shortMessageOffset: flatbuffers.Offset,
    descriptionOffset: flatbuffers.Offset,
    position: boolean,
    ciDataBinaryOffset: flatbuffers.Offset,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Message.startMessage(builder);
    Message.addId(builder, idOffset);
    Message.addMessageTypeId(builder, messageTypeId);
    Message.addMessageContentType(builder, messageContentType);
    Message.addEnumId(builder, enumId);
    Message.addDeviceType(builder, deviceType);
    Message.addEscalatorStatusMessageType(builder, escalatorStatusMessageType);
    Message.addElevatorStatusMessageType(builder, elevatorStatusMessageType);
    Message.addShortMessage(builder, shortMessageOffset);
    Message.addDescription(builder, descriptionOffset);
    Message.addPosition(builder, position);
    Message.addCiDataBinary(builder, ciDataBinaryOffset);
    Message.addCreatedAt(builder, createdAtOffset);
    Message.addUpdatedAt(builder, updatedAtOffset);
    Message.addDeletedAt(builder, deletedAtOffset);
    return Message.endMessage(builder);
  }

  unpack(): MessageT {
    return new MessageT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.messageTypeId(),
      this.messageContentType(),
      this.enumId(),
      this.deviceType(),
      this.escalatorStatusMessageType(),
      this.elevatorStatusMessageType(),
      this.shortMessage(),
      this.description(),
      this.position(),
      this.bb!.createScalarList<number>(this.ciDataBinary.bind(this), this.ciDataBinaryLength()),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: MessageT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.messageTypeId = this.messageTypeId();
    _o.messageContentType = this.messageContentType();
    _o.enumId = this.enumId();
    _o.deviceType = this.deviceType();
    _o.escalatorStatusMessageType = this.escalatorStatusMessageType();
    _o.elevatorStatusMessageType = this.elevatorStatusMessageType();
    _o.shortMessage = this.shortMessage();
    _o.description = this.description();
    _o.position = this.position();
    _o.ciDataBinary = this.bb!.createScalarList<number>(
      this.ciDataBinary.bind(this),
      this.ciDataBinaryLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): MessageT {
    const t = new MessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("message_type_id")) {
      t.messageTypeId = this.messageTypeId();
    }
    if (fieldSet.has("message_content_type")) {
      t.messageContentType = this.messageContentType();
    }
    if (fieldSet.has("enum_id")) {
      t.enumId = this.enumId();
    }
    if (fieldSet.has("device_type")) {
      t.deviceType = this.deviceType();
    }
    if (fieldSet.has("escalator_status_message_type")) {
      t.escalatorStatusMessageType = this.escalatorStatusMessageType();
    }
    if (fieldSet.has("elevator_status_message_type")) {
      t.elevatorStatusMessageType = this.elevatorStatusMessageType();
    }
    if (fieldSet.has("short_message")) {
      t.shortMessage = this.shortMessage();
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("ci_data_binary")) {
      t.ciDataBinary = this.bb!.createScalarList<number>(
        this.ciDataBinary.bind(this),
        this.ciDataBinaryLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class MessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public messageTypeId: number = 0,
    public messageContentType: number = 0,
    public enumId: number = 0,
    public deviceType: LiftType = LiftType.ELEVATOR,
    public escalatorStatusMessageType: number = 0,
    public elevatorStatusMessageType: number = 0,
    public shortMessage: string | Uint8Array | null = null,
    public description: string | Uint8Array | null = null,
    public position: boolean = false,
    public ciDataBinary: number[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.shortMessage === null || this.shortMessage === undefined) {
      throw new Error('Required field "short_message" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const shortMessage = this.shortMessage !== null ? builder.createString(this.shortMessage!) : 0;
    const description = this.description !== null ? builder.createString(this.description!) : 0;
    const ciDataBinary = Message.createCiDataBinaryVector(builder, this.ciDataBinary);
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    return Message.createMessage(
      builder,
      id,
      this.messageTypeId,
      this.messageContentType,
      this.enumId,
      this.deviceType,
      this.escalatorStatusMessageType,
      this.elevatorStatusMessageType,
      shortMessage,
      description,
      this.position,
      ciDataBinary,
      createdAt,
      updatedAt,
      deletedAt,
    );
  }

  clone(): MessageT {
    const obj = new MessageT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.messageTypeId = this.messageTypeId;
    obj.messageContentType = this.messageContentType;
    obj.enumId = this.enumId;
    obj.deviceType = this.deviceType;
    obj.escalatorStatusMessageType = this.escalatorStatusMessageType;
    obj.elevatorStatusMessageType = this.elevatorStatusMessageType;
    obj.shortMessage = this.shortMessage;
    obj.description = this.description;
    obj.position = this.position;
    obj.ciDataBinary = [...this.ciDataBinary];
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: MessageT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.messageTypeId !== other.messageTypeId) return false;
    if (this.messageContentType !== other.messageContentType) return false;
    if (this.enumId !== other.enumId) return false;
    if (this.deviceType !== other.deviceType) return false;
    if (this.escalatorStatusMessageType !== other.escalatorStatusMessageType) return false;
    if (this.elevatorStatusMessageType !== other.elevatorStatusMessageType) return false;
    if (this.shortMessage !== other.shortMessage) return false;
    if (this.description !== other.description) return false;
    if (this.position !== other.position) return false;
    if (this.ciDataBinary.length !== other.ciDataBinary.length) return false;
    for (let i = 0; i < this.ciDataBinary.length; i++) {
      if (this.ciDataBinary[i] !== other.ciDataBinary[i]) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 2);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 18, "short_message");
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 22, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
